import moment from "moment";
import React, { createContext } from "react";

const defaultDate = new Date();
export const dateContext = createContext(null);

export const DateProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [selectedDate, setSelectedDate] = React.useState({
    from: null,
    to: moment(defaultDate).add(1, "days").format("YYYY-MM-DD"),
  });
  const [selectedStatus, setSelectedStatus] = React.useState<string[]>(null);
  return (
    <dateContext.Provider value={{ selectedDate, setSelectedDate, selectedStatus, setSelectedStatus }}>
      {children}
    </dateContext.Provider>
  );
};
